<script>
  import { mapActions } from 'vuex'
  import { isEmpty } from 'lodash'
  // import auth from '../../../../domain/auth/services/auth'

  export default {
    data () {
      return {
        user: {
          email: '',
          password: ''
        },
        loginError: '',
        isLoading: false
      }
    },
    beforeCreate () {
      /* if (auth.loggedIn()) { // O usuário está logado (localStorage cache) mas as informações não estão no store
        this.$store.dispatch('attemptLogin', {
          email: ':)',
          password: 'hacker'
        })
          .then(() => {
            this.$router.replace(this.$route.query.redirect || '/')
          })
      } */
    },
    methods: {
      ...mapActions(['attemptLogin']),
      doLogin () {
        this.$bar.start()
        const user = this.user
        this.isLoading = true
        this.attemptLogin({...user})
          .then(() => {
            this.isLoading = false
            this.$bar.finish()
            if (this.$route.query.redirect && this.$route.query.redirect !== '/logout') {
              this.$router.push({path: this.$route.query.redirect})
            } else {
              this.$router.push('/')
            }
          })
          .catch((response) => {
            this.isLoading = false
            this.$bar.finish()
            this.$emit('error', response)
            this.user.password = ''
          })
      }
    },
    computed: {
      isValid () {
        const user = this.user
        return !isEmpty(user.email) && !isEmpty(user.password)
      }
    },
    activated () {
      this.$refs.user.focus()
    }
  }
</script>

<template>
    <form class="form-login" v-on:submit.prevent="doLogin">
        <label for="username">Username:</label>
        <input type="text" id="username" name="_username" ref="user" autofocus v-model="user.email"
               placeholder="Nome de usuário, email ou código"
               class="input-login username"
               required />
        <div class="clearfloat"></div>
        <label for="password">Password:</label>
        <input type="password" id="password" name="_password" v-model="user.password"
               class="input-login password"
               placeholder="Senha" required/>
        <div class="clearfloat"></div>
        <div class="s-i-l">
            <input type="checkbox" id="remember_me" name="_remember_me" value="on"
                   class="lembrar" checked/>
            <label for="remember_me">Continuar conectado</label>
        </div>

        <button type="submit" class="btn-login" :disabled="!isValid">
            <span v-if="!isLoading">Entrar</span>
            <span v-if="isLoading">Aguarde...</span>
        </button>
    </form>
</template>



// WEBPACK FOOTER //
// Login.vue?2f085844